<template>
    <LayoutSub className="employment">
        <div class="tab_menu">
            <button @click="changeContent('employment')" :class="activeContent === 'employment' ? 'selected' : ''">채용 공고</button>
            <button @click="changeContent('notice')" :class="activeContent === 'notice' ? 'selected' : ''">공지사항</button>
        </div>
        <SubSection class="content p-0" v-if="activeContent === 'employment'">
            <div class="board_top_area">
                <div class="total_post">
                    <span
                        >현재 <span class="total">{{ this.total }}건</span>의 채용이 진행 중입니다.</span
                    >
                </div>
                <router-link to="/recruit/employment_retrieve" class="go_btn"> 입사지원 조회 </router-link>
            </div>
            <div class="board_list">
                <ul>
                    <li v-for="(post, index) in recruit_data?.list" :key="index" :class="{ post_end: isRecruitClosed(post.recruitStatus) }">
                        <router-link
                            :to="{
                                path: `${$route.path}/${post.idx}`,
                                query: $route.query,
                            }"
                        >
                            <div class="col">
                                <span class="status end" v-if="isRecruitClosed(post.recruitStatus)"> 채용마감 </span>
                                <span class="status" v-else-if="isRecruitOpen(post.startDate, post.endDate, post.recruitStatus)"> 채용중 </span>
                            </div>
                            <div class="col">
                                <span class="cls">{{ post.cls }}</span>
                            </div>
                            <div class="col title">
                                <span>{{ post.subject }}</span>
                            </div>
                            <div class="col">
                                <span class="date"> {{ formatDate(post.startDate) }} ~ {{ formatDate(post.endDate) }} </span>
                            </div>
                        </router-link>
                        <div class="col" v-if="post.recruitStatus === 'Y'">
                            <RedLineButton :text="`입사지원`" :to="`/recruit/resume/apply?recruitIdx=${post.idx}`" />
                        </div>
                        <div class="col" v-else>
                            <RedLineButton :text="`입사지원`" disabled />
                        </div>
                    </li>
                </ul>
            </div>
            <PaginationComponent v-if="recruit_data" :data="recruit_data" />
        </SubSection>
        <SubSection class="content p-0" v-else>
            <ListNormalPage :data="listData" v-if="listData" />
            <LoadingWrap v-else />
        </SubSection>
    </LayoutSub>
</template>

<script>
import LayoutSub from '@/layouts/LayoutSub.vue';
import SubSection from '@/components/SubSection.vue';
import { getRecruitList, getRecruitNoticeList } from '@/api';
import ListNormalPage from '../common/ListNormalPage.vue';
import LoadingWrap from '@/components/LoadingWrap.vue';
import RedLineButton from '@/components/RedLineButton.vue';
import PaginationComponent from '@/components/PaginationComponent.vue';

export default {
    components: {
        LayoutSub,
        SubSection,
        ListNormalPage,
        LoadingWrap,
        RedLineButton,
        PaginationComponent,
    },
    data() {
        return {
            recruit_data: null,
            listData: null,
            activeContent: 'employment',
            selectedContent: null,
            total: '',
            mainContent: [
                {
                    name: '경영실적',
                },
                {
                    name: '주식',
                },
            ],
        };
    },
    async mounted() {
        this.getRecruit();
        this.getRecruitList();
    },
    watch: {
        async $route() {
            await this.getRecruit();
            await this.getRecruitList();
        },
    },
    methods: {
        async getRecruit() {
            try {
                const { paging: recruit_data } = await getRecruitList(this.$route.query);
                this.recruit_data = recruit_data;
                this.total = recruit_data.totalCnt;
            } catch (err) {
                this.recruit_data = null;
            }
        },
        async getRecruitList() {
            try {
                const { paging: listData } = await getRecruitNoticeList(this.$route.query);
                this.listData = listData;
            } catch (err) {
                this.listData = null;
            }
        },
        formatDate(recruit_data) {
            return new Date(recruit_data).toLocaleDateString('ko-KR');
        },
        isRecruitClosed(status) {
            // const today = new Date();
            // return new Date(endDate) < today;
            return status === 'B';
        },

        isRecruitOpen(startDate, endDate, status) {
            // const today = new Date();
            // const start = new Date(startDate);
            // const end = new Date(endDate);
            // return start <= today && today <= end;
            return status === 'Y';
        },
        changeContent(content) {
            this.activeContent = content;
            this.$router.replace({
                path: this.$route.path,
                query: {},
            });
        },
    },
};
</script>
